var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.141,
    height: 26.104,
    viewBox: "0 0 32.141 26.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter-brands",
    d: "M28.837,54.588c.02.285.02.571.02.857,0,8.708-6.628,18.742-18.742,18.742A18.615,18.615,0,0,1,0,71.229a13.627,13.627,0,0,0,1.591.082A13.192,13.192,0,0,0,9.769,68.5,6.6,6.6,0,0,1,3.61,63.928a8.308,8.308,0,0,0,1.244.1,6.967,6.967,0,0,0,1.733-.224,6.588,6.588,0,0,1-5.282-6.465v-.082a6.634,6.634,0,0,0,2.977.836,6.6,6.6,0,0,1-2.039-8.81,18.724,18.724,0,0,0,13.582,6.893,7.436,7.436,0,0,1-.163-1.509,6.593,6.593,0,0,1,11.4-4.507,12.969,12.969,0,0,0,4.181-1.591,6.569,6.569,0,0,1-2.9,3.63,13.205,13.205,0,0,0,3.793-1.02,14.16,14.16,0,0,1-3.3,3.406Z",
    transform: "translate(0 -48.082)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.37c1b251.svg";
export { ForwardRef as ReactComponent };